import Vue from 'vue'
import Router from 'vue-router'

import october_schedule from './module/october_schedule'
import course from './module/course'
import task from './module/task'
import help from './module/help'
import activity from './module/activity'
import sku from './module/sku'
import vip from './module/vip'
import fhrm from './module/fhrm'
import question from './module/question'
import invite from './module/invite'

Vue.use(Router)

let router =  new Router({
  // 去掉地址栏的#号
  routes: [
    {
      path: '/test',
      name: 'test',
      meta: {
        title: '测试'
      },
      component: () => import('views/test/demo')
    },
    {
      path: '/fetal_heart',
      meta: {
        title: '孕橙智能胎心仪'
      },
      name: 'fetal_heart',
      component: () => import('views/fetal_heart')
    },
    {
      path: '/fetal_heart/record',
      name: 'fetal_heart_record',
      meta: {
        title: '胎心记录'
      },
      component: () => import('views/fetal_heart/record')
    },
    {
      path: '/fetal_heart/guide',
      name: 'fetal_heart_guide',
      meta: {
        title: '胎心仪使用指南'
      },
      component: () => import('views/fetal_heart/guide')
    },
    {
      path: '/ebook/detail',
      name: 'ebook_detail',
      meta: {
        title: '从零开始的自然孕育之路'
      },
      component: () => import('views/ebook')
    },
    {
      path: '/pregnant_in_9_cycles/policy',
      meta: { title: '九“月”孕成计划' },
      name: 'policy_9_cycles',
      component: () => import('views/pregnant_in_9_cycles/policy.vue')
    },
    {
      path: '/pregnant_in_9_cycles/policy_v4',
      meta: { title: '九“月”孕成保障计划协议' },
      name: 'policy_9_cycles',
      component: () => import('views/pregnant_in_9_cycles/policy_v4.vue')
    },
    {
      path: '/pregnant_in_9_cycles/explain',
      meta: { title: '帮助' },
      name: 'explain_9_cycles',
      component: () => import('views/pregnant_in_9_cycles/explain_9_cycles.vue')
    },
    {
      path: '/pregnant_in_9_cycles/help',
      meta: { title: '常见问题' },
      name: 'help_9_cycles',
      component: () => import('views/pregnant_in_9_cycles/help_9_cycles.vue')
    },
    {
      path: '/pregnant_in_9_cycles/help2',
      meta: { title: '九“月”孕成保障计划协议' },
      name: 'help_9_cycles2',
      component: () => import('views/pregnant_in_9_cycles/components/help.vue')
    },
    {
      path: '/pregnant_in_9_cycles/goods',
      meta: { title: '备孕产品列表' },
      name: 'goods_9_cycles',
      component: () => import('views/pregnant_in_9_cycles/goods_9_cycles.vue')
    },
    {
      path: '/pregnant_in_9_cycles',
      meta: { title: '九“月”孕成' },
      name: 'pregnant_in_9_cycles',
      component: () => import('views/pregnant_in_9_cycles/pregnant_in_9_cycles.vue')
    },
    {
      path: '/pregnant_in_9_cycles/report_list',
      meta: { title: '智能周期分析报告' },
      name: 'report_list_9_cycles',
      component: () => import('views/pregnant_in_9_cycles/report_list.vue'),
      beforeEnter: (to, from, next) => {
        if (to.query.example_type && '1' === to.query.example_type) {
          document.title = '孕橙标准图表'
        } else if (to.query.example_type && '2' === to.query.example_type) {
          document.title = '医用基础体温表'
        } else if (to.query.example_type && '3' === to.query.example_type) {
          document.title = '咨询备孕教练'
        } else if (to.query.example_type && '4' === to.query.example_type) {
          document.title = '绑定老公'
        }
        next()
      }
    },
    {
      path: '/pregnant_in_9_cycles/report_example_by_group',
      meta: { title: '九“月”孕成' },
      name: 'report_example_by_group',
      component: () => import('views/pregnant_in_9_cycles/report_example_by_group.vue'),
      beforeEnter: (to, from, next) => {
        if ((to.query.example_type && '1' === to.query.example_type) || (to.query.type && '1' === to.query.type)) {
          document.title = '孕橙标准图表'
        } else if ((to.query.example_type && '2' === to.query.example_type) || (to.query.type && '2' === to.query.type)) {
          document.title = '医用基础体温表'
        }
        next()
      }
    },
    {
      path: '/vip/report_example',
      meta: { title: '智能周期分析报告' },
      name: 'report_example',
      component: () => import('views/pregnant_in_9_cycles/report_example_unlock_vip.vue'),
      beforeEnter: (to, from, next) => {
        if ((to.query.example_type && '1' === to.query.example_type) || (to.query.type && '1' === to.query.type)) {
          document.title = '孕橙标准图表'
        } else if ((to.query.example_type && '2' === to.query.example_type) || (to.query.type && '2' === to.query.type)) {
          document.title = '医用基础体温表'
        } else if ((to.query.example_type && '3' === to.query.example_type) || (to.query.type && '3' === to.query.type)) {
          document.title = '咨询备孕教练'
        } else if ((to.query.example_type && '4' === to.query.example_type) || (to.query.type && '4' === to.query.type)) {
          document.title = '绑定老公'
        }else if ((to.query.example_type && '5' === to.query.example_type) || (to.query.type && '5' === to.query.type)) {
          document.title = '经期分析'
        }
        next()
      }
    },
    {
      path: '/pregnant_in_9_cycles_mm',
      meta: { title: '九“月”孕成' },
      name: 'pregnant_in_9_cycles_mm',
      component: () => import('views/pregnant_in_9_cycles/pregnant_in_9_cycles_mm.vue')
    },
    {
      path: '/analysis_report/cycles',
      meta: { title: '智能周期分析报告' },
      name: 'analysis_report_cycles',
      component: () => import('views/analysis_report/cycles.vue')
    },
    {
      path: '/analysis_report/report',
      meta: { title: '智能周期分析报告' },
      name: 'analysis_report',
      component: () => import('views/analysis_report/report.vue')
    },
    {
      path: '/analysis_report/advice_detail',
      meta: { title: '' },
      name: 'advice_detail',
      component: () => import('views/analysis_report/advice_detail.vue')
    },
    {
      path: '/pregnant_important',
      meta: { title: '立即加入孕妈群' },
      name: 'pregnant_important',
      component: () => import('views/pregnant_important/index.vue')
    },
    {
      path: '/pregnant_important_knowledge1',
      meta: { title: '孕早期需坚持测基础体温' },
      name: 'pregnant_important_knowledge1',
      component: () => import('views/pregnant_important/knowledge1.vue')
    },
    {
      path: '/pregnant_important_knowledge2',
      meta: { title: '孕早期监测HCG的重要性' },
      name: 'pregnant_important_knowledge2',
      component: () => import('views/pregnant_important/knowledge2.vue')
    },
    {
      path: '/pregnant_important_knowledge3',
      meta: { title: '胎心仪监护胎儿健康' },
      name: 'pregnant_important_knowledge3',
      component: () => import('views/pregnant_important/knowledge3.vue')
    },
    {
      path: '/pregnant_important_knowledge4',
      meta: { title: '你确定你的试纸用对了吗？' },
      name: 'pregnant_important_knowledge4',
      component: () => import('views/pregnant_important/knowledge4.vue')
    },
    {
      path: '/pregnant_important_knowledge5',
      meta: { title: '拒绝无效备孕，怎么根据排卵试纸提高受孕率' },
      name: 'pregnant_important_knowledge5',
      component: () => import('views/pregnant_important/knowledge5.vue')
    },
    {
      path: '/pregnant_important_knowledge6',
      meta: { title: '卵子什么时候老化，试纸强阳后怎么安排？' },
      name: 'pregnant_important_knowledge6',
      component: () => import('views/pregnant_important/knowledge6.vue')
    },
    {
      path: '/pregnant_important_knowledge7',
      meta: { title: '排卵试纸LH变化曲线图，你是哪种曲线？' },
      name: 'pregnant_important_knowledge7',
      component: () => import('views/pregnant_important/knowledge7.vue')
    },
    {
      path: '/pregnant_important_knowledge8',
      meta: { title: '新人专区' },
      name: 'pregnant_important_knowledge8',
      component: () => import('views/pregnant_important/knowledge8.vue')
    },
    {
      path: '/pregnant_master_more',
      meta: { title: '更多助孕案例解读' },
      name: 'pregnant_master_more',
      component: () => import('views/pregnant_master/more.vue'),
    },
    {
      path: '/pregnant_master/:id',
      meta: { title: '优孕师助孕经典案例' },
      name: 'pregnant_master_id',
      component: () => import('views/pregnant_master/index.vue'),
      beforeEnter: (to, from, next) => {
        if (to.params.id  ==='21') {
          document.title = '居家筛查宫外孕'
        }else if(to.params.id  ==='25'){
          document.title = '居家做胎心监护'
        }
        next()
      }
    },
    {
      path: '/pregnant_master',
      meta: { title: '优孕师助孕经典案例' },
      name: 'pregnant_master',
      component: () => import('views/pregnant_master/index.vue')
    },
    {
      path: '/pregnant_master_live',
      meta: { title: '优孕师读图' },
      name: 'pregnant_master_live',
      component: () => import('views/pregnant_master/live.vue')
    },
    {
      path: '/pregnant_master_receive',
      meta: { title: '优孕师领取方式' },
      name: 'pregnant_master_receive',
      component: () => import('views/vip/exchange.vue')
    },
    {
      path: '/fetal_heart/pregnancy_week_desc',
      name: 'fetal_heart_pregnancy_week_desc',
      meta: {
        title: '胎心记录'
      },
      component: () => import('views/fetal_heart/pregnancy_week_desc')
    },
    {
      path: '/pregnant_weeks',
      meta: { title: '胎宝发育动态' },
      name: 'pregnant_weeks',
      component: () => import('views/fetal_heart/pregnant_weeks.vue')
    },
    {
      path: '/fetal_heart/publicity',
      meta: { title: '在家听胎心' },
      name: 'fetal_heart_publicity',
      component: () => import('views/fetal_heart/publicity.vue')
    },
    {
      path: '/fetal_heart/monitor',
      meta: { title: '胎心分析' },
      name: 'fetal_heart_monitor',
      component: () => import('views/fetal_heart/monitor.vue')
    },
    {
      path: '/fetal_heart/pregnancy_week_activity_8_11',
      meta: { title: '妈妈，准备好听宝宝的声音了吗~' },
      name: 'pregnancy_week_activity_8_11',
      component: () => import('views/fetal_heart/pregnancy_week_activity_8_11.vue')
    },
    {
      path: '/fetal_heart/pregnancy_week_activity_12_15',
      meta: { title: '爸爸，准备好听宝宝的声音了吗~' },
      name: 'pregnancy_week_activity_12_15',
      component: () => import('views/fetal_heart/pregnancy_week_activity_12_15.vue')

    },
    {
      path: '/fetal_heart/pregnancy_week_activity_16_40',
      meta: { title: '胎心日记，分享给我们的小家，记录宝宝成长发育' },
      name: 'pregnancy_week_activity_16_40',
      component: () => import('views/fetal_heart/pregnancy_week_activity_16_40.vue')

    },
    {
      path: '/test_temp_clock',
      meta: { title: '测温找排卵计划' },
      name: 'test_temp_clock',
      component: () => import('views/test_temp_clock/test_temp_clock.vue')
    },
    {
      path: '/test_temp_clock_buy',
      meta: { title: '测温找排卵计划' },
      name: 'test_temp_clock_buy',
      component: () => import('views/test_temp_clock/test_temp_clock_buy.vue')
    },
    {
      path: '/fhrm_protocol',
      meta: { title: '使用知情同意书' },
      name: 'fhrm_protocol',
      component: () => import('views/fhrm_protocol/index.vue')
    },
    {
      path: '/glm_mp4',
      meta: { title: '高灵敏验孕棒使用视频' },
      name: 'glm_mp4',
      component: () => import('views/help/fhrm_video_glm.vue')
    },
    {
      path: '/pregnant_checkup/detail',
      meta: { title: '产检详情' },
      name: 'pregnant_checkup',
      component: () => import('views/pregnant_checkup/detail.vue')
    },
    {
      path: '/pregnant_master_area',
      meta: { title: '优孕师专区' },
      name: 'pregnant_master_live',
      component: () => import('views/pregnant_master/pregnant_master_area.vue')
    },
    {
      path: '/pregnant_master_area/applicable_people',
      meta: { title: '适用人群' },
      name: 'pregnant_master_live',
      component: () => import('views/pregnant_master/pregnant_master_area_detail/applicable_people.vue')
    },
    {
      path: '/pregnant_master_area/guiding_philosophy',
      meta: { title: '指导理念' },
      name: 'pregnant_master_live',
      component: () => import('views/pregnant_master/pregnant_master_area_detail/guiding_philosophy.vue')
    },
    {
      path: '/pregnant_master_area/pregnant_master_detail',
      meta: { title: '优孕师简介' },
      name: 'pregnant_master_live',
      component: () => import('views/pregnant_master/pregnant_master_area_detail/pregnant_master_detail.vue')
    },
    {
      path: '/pregnant_master_area/doctor_detail',
      meta: { title: '医生简介' },
      name: 'doctor_live',
      component: () => import('views/pregnant_master/pregnant_master_area_detail/doctor_detail.vue')
    },
    {
      path: '/report_display',
      // meta: { title: '产检讲解' },
      name: 'report_display',
      component: () => import('views/pregnant_master/report_display.vue')
    },
    {
      path: '/sex_hormone',
      meta: { title: '性激素六项' },
      name: 'report_display',
      component: () => import('views/pregnant_master/sex_hormone_report.vue')
    },
    {
      path: '/preg_master_detail',
      meta: { title: '优孕师团队' },
      name: 'report_display',
      component: () => import('views/pregnant_master/preg_master_detail.vue')
    },
    {
      path: '/conditioning_analysis',
      meta: { title: '备孕调理分析' },
      name: 'pregnant_master_live',
      component: () => import('views/pregnant_master/conditioning_analysis.vue')
    },
    {
      path: '/no_preg_report/promotion',
      meta: { title: '未孕报告' },
      name: 'no_preg_report_promotion',
      component: () => import('views/analysis_report/no_preg_report/no_preg_report_promotion.vue')
    },
    {
      path: '/no_preg_report/report',
      meta: { title: '未孕报告' },
      name: 'no_preg_report',
      component: () => import('views/analysis_report/no_preg_report/no_preg_report.vue')
    },
    {
      path: '/no_preg_report/report-husband',
      meta: { title: '未孕报告' },
      name: 'no_preg_report',
      component: () => import('views/analysis_report/no_preg_report/no_preg_report_husband.vue')
    },
    {
      path: '/test_temp_clock/coupon_detail',
      meta: { title: '所获奖励详情' },
      name: 'coupon_detail',
      component: () => import('views/test_temp_clock/coupon_detail.vue')
    },
    {
      path: '/test_temp_clock/common_question',
      meta: { title: '常见问题' },
      name: 'coupon_detail',
      component: () => import('views/test_temp_clock/common_question.vue')
    },
    {
      path: '/test_temp_clock/policy',
      meta: { title: '计划规则升级说明' },
      name: 'policy',
      component: () => import('views/test_temp_clock/policy.vue')
    },
    {
      path: '/hcg/hcg_marketing',
      meta: { title: 'HCG风险筛查' },
      name: 'hcg',
      component: () => import('views/hcg/hcg_marketing.vue')
    },
    {
      path: '/preg_content/ebook_summary',
      meta: { title: '电子书' },
      name: 'hcg',
      component: () => import('views/preg_content/ebook_summary.vue')
    },
    {
      path: '/preg_content/condition_area',
      meta: { title: '调理专区' },
      name: 'hcg',
      component: () => import('views/preg_content/condition_area.vue')
    },   
    {
      path: '/register/preparation_option_detail',
      meta: { title: '知孕法备孕方案' },
      name: 'preparation',
      component: () => import('views/register/preparation_options_detail.vue')
    },
    {
      path: '/register/preparation_options',
      meta: { title: '知孕法备孕方案' },
      name: 'preparation',
      component: () => import('views/register/preparation_options.vue')
    },
    {
      path: '/help/master_qrcode',
      meta: { title: '扫码添加优孕师' },
      name: 'preparation',
      component: () => import('views/help/qrCode.vue')
    },
    {
      path: '/qrCode/masterQrCode',
      meta: { title: '知孕法备孕方案' },
      name: 'preparation',
      component: () => import('views/qrCode/masterQrCode.vue'),
      beforeEnter: (to, from, next) => {
        document.title = to.query.page_title
        next()
      }
    },
    ...october_schedule,
    ...course,
    ...task,
    ...help,
    ...activity,
    ...sku,
    ...vip,
    ...fhrm,
    ...question,
    ...invite,
  ]
})

export default router

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
})